import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';

export default function* bookingDetailsSaga() {
  yield all([
    fork(listenLoad),
  ]);
}
